import { render } from "./YPPagination.vue?vue&type=template&id=37e03a36"
import script from "./YPPagination.vue?vue&type=script&lang=js"
export * from "./YPPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__